import React from 'react';
import { Link } from 'react-router-dom';

const EventsContextMenu = ({
  bookedFlag, changePage, matchId, oddsHistoryPage, matchTimelinePage,
}) => (
  <>
    {bookedFlag
      ? (
        <Link
          to={`${oddsHistoryPage}/${matchId}`}
          onClick={changePage}
        >
          <div className="context-menu__list-item">
            Odds History
          </div>
        </Link>
      )
      : null}
    <Link
      to={`${matchTimelinePage}/${matchId}`}
      onClick={changePage}
    >
      <div className="context-menu__list-item">
        Match timeline
      </div>
    </Link>
  </>
);
export default EventsContextMenu;
